import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../config/Config.js";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const VerifyOTP = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log('state >>', state);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [otptext, setotptext] = useState("");
  const [otperrormessage, setotperrormessage] = useState("");
  const dispatch = useDispatch(); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [otpSent, setOtpSent] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(120); // 2 minutes
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (!otpSent) return;

    if (secondsLeft === 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [otpSent, secondsLeft]);

  const formatTime = (secs) => {
    const min = Math.floor(secs / 60);
    const sec = secs % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const resendotpfunc = async() => {
    if (!state.email) {
      alert("Email is required");
      return;
    }

    var data = {
    email: state.email,
  }
  console.log('data >>', data);

  try {
    const res = await axios.post(
      apiUrl + "userresendotp",
      data,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (res.data.status === "success") {
      setSecondsLeft(120);
      setCanResend(false);

    } else {
      alert(res.data.message || "Something went wrong.");
    }
  } catch (err) {
    console.error(err);
    alert(
      "Error logging in: " +
        (err.response?.data?.message || err.message || "Network error.")
    );
  } finally {
    // setLoading(false);
  }
    
  }




  const handleSubmit = async (e) => {
    e.preventDefault();

    var isotperror = false;
    if (!otptext) {
      // alert("Empty OTP");
      isotperror = true;
      setotperrormessage("OTP cannot be empty");
      return;
    } else {
      if(otptext?.length == 6) {
        isotperror = false;
        setotperrormessage("");
      } else {  
        isotperror = true;
        setotperrormessage("Invalid OTP");
        return;
      }
    }

    if (!state.email) {
      alert("Email is required");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        apiUrl + "user-verify-otp",
        {
          email: state.email,
          otp: otptext 
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        // dispatch({ type: "customerdata", payload: res.data.data })
        // navigate("/createstory");
        const user = {
            email: state.email,
            reset_token: res.data.reset_token,
        };
        navigate("/reset-password", { state: user });
      } else {
        alert(res.data.message || "Something Went Wrong!!");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  useEffect(() => {
      setOtpSent(true);
      setSecondsLeft(120);
      setCanResend(false);
    }, [])

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        {/* Canonical Tag */}
        <link rel="canonical" href="https://theomsaga.com/login" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Login to TheOmSaga | Share Your Spiritual Stories"
        />
        <meta
          property="og:description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />
        <meta property="og:url" content="https://theomsaga.com/login" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/login-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
        </script>
      </Helmet>

      <div className="login-page-container">
        <div className="login-page-scroll verifyotp-page-scroll verifyotp-page-scroll-div">
          <div className="login-page-main-content">
            <div>
              <p className="login-page-title">VERIFY OTP</p>
            </div>

            <form className="login-page-form" onSubmit={handleSubmit}>
              <input
                className="login-page-input"
                type="email"
                name="email"
                placeholder="Email"
                value={state?.email}
                disabled
              />
              <input
                className="login-page-input"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Enter OTP sent to your e-mail"
                value={otptext}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  setotptext(onlyNumbers);
                }}
                maxLength={6}
              />
              {
                otperrormessage ?
                <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{otperrormessage}</p>
                </div>
                : null
              }

              <div className="forgetpassworddiv resetpassworddiv">
                {!canResend ? (
                  <p style={{ fontWeight: 400 }}>
                    Resend OTP in <strong>{formatTime(secondsLeft)}</strong>
                  </p>
                ) : (
                  <p
                    onClick={() => {
                      resendotpfunc();
                    }}
                  >
                    Resend OTP
                  </p>
                )}
              </div>

              <button
                className="login-page-button"
                type="submit"
                disabled={loading}
              >
                {loading ? "Verifying.." : "Verify & Reset"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyOTP;
